import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GotoModalComponent } from '../goto-modal/goto-modal.component';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  breakpointsSubscription: Subscription;
  routerSubscription: Subscription;

  mobile = false;

  /** 仅 /buy 页面显示商品搜索 */
  showSearch = false;

  /** 搜索面板开关状态（用于统一渲染背景遮罩） */
  desktopSearchOpen = false;
  mobileSearchOpen = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private modal: MatDialog,
    private router: Router
  ) {
    this.breakpointsSubscription = this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe((r) => {
        this.mobile = r.matches;
        this.updateBodyClass();
      });
    this.routerSubscription = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.showSearch = this.isBuyPage();
        if (!this.showSearch) {
          // 离开 /buy：搜索实例被销毁，重置面板状态，避免残留遮罩 / 滚动锁
          this.desktopSearchOpen = false;
          this.mobileSearchOpen = false;
        }
        this.updateBodyClass();
      });
    this.showSearch = this.isBuyPage();
  }

  ngOnInit(): void {
    this.showSearch = this.isBuyPage();
    this.updateBodyClass();
  }

  ngOnDestroy(): void {
    this.breakpointsSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
    document.body.classList.remove('has-buy-search-mobile');
    this.setScrollLock(false);
  }

  private isBuyPage(): boolean {
    return (this.router.url || '').split('?')[0] === '/buy';
  }

  /** 搜索面板开关回调：记录状态并同步遮罩 / 移动端滚动锁 */
  onSearchOpenChange(kind: 'desktop' | 'mobile', open: boolean) {
    if (kind === 'desktop') {
      this.desktopSearchOpen = open;
    } else {
      this.mobileSearchOpen = open;
    }
    this.updateBodyClass();
  }

  /**
   * /buy 移动端在 header 下多一行搜索框（52px），
   * 通过 body class 让页面内容 margin / 分类面板 sticky top 自动让位；
   * 沉浸式面板打开时同时锁定页面滚动。
   */
  private updateBodyClass() {
    const hasSearchRow = this.showSearch && this.mobile;
    if (hasSearchRow) {
      document.body.classList.add('has-buy-search-mobile');
    } else {
      document.body.classList.remove('has-buy-search-mobile');
    }
    this.setScrollLock(hasSearchRow && this.mobileSearchOpen);
  }

  /** 移动端沉浸搜索面板打开时锁住页面滚动（html + body 双保险） */
  private setScrollLock(locked: boolean) {
    document.documentElement.classList.toggle('buy-search-scroll-lock', locked);
    document.body.classList.toggle('buy-search-scroll-lock', locked);
  }

  hover = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.scrollY;
    this.hover = offset > 0;
  }

  goto(name: string) {
    this.modal.open(GotoModalComponent, {
      data: name,
    });
  }
}
